import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import { Button, Select, Tabs, TabPane, Form, FormItem, Input, Option } from 'element-ui';
import App from './App.vue'
import router from './router'
import global_vars from './global'
Vue.prototype.$global_vars = global_vars;
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
import * as rules from 'vee-validate/dist/rules';

// install rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
localize("zh_CN", zh_CN);
localize({
  zh_CN: {
    fields: {
      展位面积: {
        min_value: '展位面积必须为大于9的整数',
        numeric: '展位面积必须为大于9的整数',
      },
      已阅读:{
        required: '请确认勾选同意《保险条款》《客户告知书》'
      }
    }
  }
});


// Install components globally
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.use(ElementUI);

Vue.config.productionTip = false
// Vue.component(Form.name, Form);
// Vue.component(FormItem.name, FormItem);
// Vue.component(Button.name, Button);
// Vue.component(Select.name, Select);
// Vue.component(Tabs.name, Tabs);
// Vue.component(TabPane.name, TabPane);
// Vue.component(Input.name, Input);
// Vue.component(Option.name, Option);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
